export default {
    slug: 'surveys',
    ability: 'surveys',
    routes: [
        {
            path: 'surveys',
            name: 'survey-list',
            component: () => import('@modules/Surveys/Resources/js/pages/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'survey-preview',
                    component: () => import('@modules/Surveys/Resources/js/pages/Preview.vue'),
                    redirect: { name: 'survey-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/surveys/:id(\\d+)',
                            name: 'survey-overview',
                            component: () => import('@modules/Surveys/Resources/js/pages/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'responses',
                            name: 'survey-responses',
                            component: () => import('@modules/Surveys/Resources/js/pages/preview/Responses.vue'),
                            props: true
                        },
                        {
                            path: 'analytics',
                            name: 'survey-analytics',
                            component: () => import('@modules/Surveys/Resources/js/pages/preview/Analytics.vue'),
                            props: true
                        },
                        {
                            path: 'comments',
                            name: 'survey-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'survey-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        // Survey Builder (full page)
        {
            path: 'surveys/new',
            name: 'survey-new',
            component: () => import('@modules/Surveys/Resources/js/pages/Builder.vue')
        },
        {
            path: 'surveys/:id(\\d+)/edit',
            name: 'survey-edit',
            component: () => import('@modules/Surveys/Resources/js/pages/Builder.vue'),
            props: route => ({ id: route.params.id })
        },
        // Survey Templates
        {
            path: 'surveys/templates',
            name: 'survey-template-list',
            component: () => import('@modules/Surveys/Resources/js/pages/Templates.vue')
        }
    ],
    nav: () => ({
        section: 'marketing',
        items: [
            {
                title: i18n.t('Surveys'),
                icon: 'clipboard-text-outline',
                to: { name: 'survey-list' }
            }
        ]
    })
};
